import {
  GET_ACCESS_LEVEL_SUCCESS,
  GET_AUTHORSHIP_TYPES_SUCCESS,
  GET_CONTENT_TYPES_SUCCESS,
  GET_IDENTITY_SYSTEM_SUCCESS,
  GET_LANGUAGES_SUCCESS,
  GET_PUBLICATION_THEMATIC_SUCCESS,
  GET_PUBLICATION_TYPE_SUCCESS,
  GET_SCIENCE_AREA_SUCCESS,
  GET_SCIENCE_FIELD_SUCCESS,
  GET_SETTINGS_ACCESS_LEVELS_SUCCESS,
  GET_UPLOAD_FILE_EXTENTIONS_SUCCESS,
  GET_UPLOAD_FILE_MIME_SUCCESS,
  GET_UPLOAD_ITEM_TYPES_SUCCESS,
  SET_LOADING_CATALOGS,
} from 'redux/constants';
import { ActionType } from '../../types/reduxTypes';
import { ClsItem } from 'types/clsType';
import { ClsItemsStateType } from 'types/stateTypes';

const initialState: ClsItemsStateType = {
  accessLevel: [],
  authorshipTypes: [],
  contentTypes: [],
  identitySystem: [],
  languages: [],
  loadingCatalogs: false,
  publicationThematic: [],
  publicationTypes: [],
  scienceArea: [],
  scienceField: [],
  settingsAcessLevels: [],
  uploadFileExtensions: [],
  uploadFileMime: [],
  uploadItemTypes: [],
};

export default (state = initialState, action: ActionType<unknown>): ClsItemsStateType => {
  switch (action.type) {
    case GET_UPLOAD_FILE_EXTENTIONS_SUCCESS: {
      return {
        ...state,
        uploadFileExtensions: action.payload as ClsItem[],
      };
    }
    case GET_UPLOAD_FILE_MIME_SUCCESS: {
      return {
        ...state,
        uploadFileMime: action.payload as ClsItem[],
      };
    }
    case GET_PUBLICATION_TYPE_SUCCESS: {
      return {
        ...state,
        publicationTypes: (action.payload as ClsItem[]).sort((a, b) => a.term.localeCompare(b.term)),
      };
    }
    case GET_PUBLICATION_THEMATIC_SUCCESS: {
      return {
        ...state,
        publicationThematic: (action.payload as ClsItem[]).sort((a, b) => {
          let result = !a.code || !b.code ? 0 : a.code.localeCompare(b.code);
          if (!result) result = a.term.localeCompare(b.term);
          return result;
        }),
      };
    }
    case GET_SCIENCE_FIELD_SUCCESS: {
      return {
        ...state,
        scienceField: action.payload as ClsItem[],
      };
    }
    case GET_SCIENCE_AREA_SUCCESS: {
      return {
        ...state,
        scienceArea: action.payload as ClsItem[],
      };
    }
    case GET_LANGUAGES_SUCCESS: {
      return {
        ...state,
        languages: (action.payload as ClsItem[]).sort((a, b) => a.term.localeCompare(b.term)),
      };
    }
    case GET_AUTHORSHIP_TYPES_SUCCESS: {
      return {
        ...state,
        authorshipTypes: action.payload as ClsItem[],
      };
    }
    case GET_IDENTITY_SYSTEM_SUCCESS: {
      return {
        ...state,
        identitySystem: action.payload as ClsItem[],
      };
    }
    case GET_ACCESS_LEVEL_SUCCESS: {
      return {
        ...state,
        accessLevel: action.payload as ClsItem[],
      };
    }
    case GET_UPLOAD_ITEM_TYPES_SUCCESS: {
      return {
        ...state,
        uploadItemTypes: action.payload as ClsItem[],
      };
    }
    case GET_CONTENT_TYPES_SUCCESS: {
      return {
        ...state,
        contentTypes: action.payload as ClsItem[],
      };
    }
    case SET_LOADING_CATALOGS: {
      return {
        ...state,
        loadingCatalogs: action.payload as boolean,
      };
    }
    case GET_SETTINGS_ACCESS_LEVELS_SUCCESS: {
      return {
        ...state,
        settingsAcessLevels: action.payload as ClsItem[],
      };
    }
    default: {
      return state;
    }
  }
};
